import React from "react";
import { View } from "react-native";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range.js";
import tw from "twrnc";

import Text from "@/components/shared/AppText";
import OnboardingButton from "@/components/shared/OnboardingButton";
import { t } from "@/localization";

// The server only accepts a stream on a real event from 1 hour before its
// start until 24 hours after (nginxWebhook2: event_window_*_datetime_utc) and
// refuses it silently otherwise, so the browser studio would just keep failing.
// Tests and events that are live already are never blocked.
export const goLiveWindow = (event, now = moment()) => {
  if (!event || event.is_test || event.event_status === "live") {
    return { open: true };
  }
  const start = event.event_window_start_datetime_utc;
  const end = event.event_window_end_datetime_utc;
  if (start && now.isBefore(start)) {
    return { open: false, tooEarly: true, at: moment(start) };
  }
  if (end && now.isAfter(end)) {
    return { open: false, tooLate: true, at: moment(end) };
  }
  return { open: true };
};

const when = (at, event) =>
  at
    .clone()
    .tz(event.event_timezone || moment.tz.guess())
    .format(t("dddd, MMM D [at] h:mm A z"));

// Shown instead of the browser studio while the go-live window is closed.
const GoLiveWindowNotice = ({ event, window, onTest, onChangeDate }) => {
  if (window.tooEarly) {
    return (
      <View style={tw`py-4`}>
        <Text style={tw`text-base font-bold mb-1`}>
          {t("Go Live opens {when}", { when: when(window.at, event) })}
        </Text>
        <Text style={tw`mb-4`}>
          {t(
            "That's 1 hour before the start. Until then, a free test checks your camera and sound – guests won't see it."
          )}
        </Text>
        {onTest && (
          <OnboardingButton
            text={t("Start free test in browser")}
            icon="videocam-outline"
            bordered
            dark
            onPress={onTest}
          />
        )}
      </View>
    );
  }
  return (
    <View style={tw`py-4`}>
      <Text style={tw`text-base font-bold mb-1`}>
        {t("Going live closed {when}", { when: when(window.at, event) })}
      </Text>
      {event.event_status === "upcoming" && (
        <>
          <Text style={tw`mb-4`}>
            {t("To go live, change the event date – it's free.")}
          </Text>
          {onChangeDate && (
            <OnboardingButton
              text={t("Change the date")}
              onPress={onChangeDate}
            />
          )}
        </>
      )}
    </View>
  );
};

export default GoLiveWindowNotice;
